var React = require('react');
const { connect } = require('react-redux');
const { withTranslation } = require('react-i18next');
const dayjs = require('../../../utils/dayjsConfig');
var userActions = require('userActions');
const { useEffect, useState } = require('react');
var {
  getLatestNotificationDate,
} = require('../../../managers/notificationsListCache');

const NotificationIconContainer = (props) => {
  const [shouldDisplayRedNotificationDot, setShouldDisplayRedNotificationDot] =
    useState(false);

  useEffect(() => {
    if (Object.keys(props.userData).length === 0) return;
    const latestNotificationDate = getLatestNotificationDate(props.feedItems);

    if (
      (props.userData.hasOwnProperty('meta_data') &&
        Object.keys(props.userData?.meta_data).length === 0) ||
      latestNotificationDate === 0 ||
      latestNotificationDate >
        props.userData?.meta_data?.notifications?.notifications_last_visit ||
      props.userData?.meta_data?.notifications?.notifications_last_visit === 0
    ) {
      setShouldDisplayRedNotificationDot(true);
    } else {
      setShouldDisplayRedNotificationDot(false);
    }
  }, [props.feedItems, props.userData]);

  const updateUserLastVisit = () => {
    let copyOfUserData = {};
    Object.assign(copyOfUserData, props.userData);

    if (
      !copyOfUserData.hasOwnProperty('meta_data') ||
      Object.keys(copyOfUserData['meta_data']).length === 0
    ) {
      copyOfUserData['meta_data'] = {
        notifications: {
          notifications_last_visit: dayjs().unix(),
        },
      };
    } else {
      copyOfUserData['meta_data'] = {
        notifications: {
          ...copyOfUserData['meta_data']['notifications'],
          notifications_last_visit: dayjs().unix(),
        },
      };
    }
    props.setUserMetaData({
      meta_data_notifications_last_visit:
        copyOfUserData['meta_data']['notifications'][
          'notifications_last_visit'
        ],
    });
    setShouldDisplayRedNotificationDot(false);
    mixpanel.track('Notification Center Panel Upload');
  };

  const OnNotificationIconClicked = () => {
    props.onIconClicked();
    updateUserLastVisit();

    mixpanel.track_pageview({
      page: 'Notifications Center',
      'Total Notifications': props.feedItems.length,
      'Has Unread Notifications': shouldDisplayRedNotificationDot,
    });
  };

  return (
    <div
      className='notificationsBtn'
      data-toggle='modal'
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginLeft: 'auto',
        marginTop: '2px',
        marginRight: '0px',
      }}
      onClick={() => {
        OnNotificationIconClicked();
      }}
    >
      <img
        src={
          shouldDisplayRedNotificationDot
            ? require('images/icons/notifications_icon_red.svg')
            : require('images/icons/notification_icon.svg')
        }
      />
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    userData: state.authentication_data.user_data,
    feedItems: state.authentication_data.notifications_feed?.items || [],
  };
};

const mapDispatchToProps = {
  setUserMetaData: userActions.set_user_meta_data,
};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(NotificationIconContainer));
